import loginBackground from "./loginBackground.png";
import mainLogo from "./mainLogo.png";
import profile1 from "./profile1.png";

export const images = {
  loginBackground,
  mainLogo,
  profile1,
};
